module.exports = __webpack_public_path__ + "img/coors-light-layout.aebc1705.jpg";